export default __webpack_public_path__ + "static/media/img-0081-japan-full-face.6e5007be.png";